// @flow
import React from 'react';

import { t } from 'Src/i18n';
import Participants from 'Components/widgets/trip-information/participants/Participants.jsx';
import { DEFAULT_DATE_FORMAT } from 'Components/widgets/cruise-booking/CruiseBooking.jsx';

type Props = {
  adultsNumber: number,
  cruise: {
    fromToDestination: string,
    departureDate: string,
  },
  dateFormat: string,
  kids: Array<*>,
  product: {|
    id: string,
    adultOnly: boolean,
    duration: string,
    dateRange: string,
    minAuthorizedAge: {|
      formattedValue: string,
      value: number,
    |},
    minAgeErrorMessage: {|
      formattedValue: string,
    |},
  |},
  setAdultsNumber: () => void,
  setKids: () => void,
};

export const CruiseParticipants = (props: Props) => {
  const {
    adultsNumber,
    cruise = {},
    dateFormat = DEFAULT_DATE_FORMAT,
    kids,
    product,
    setAdultsNumber,
    setKids,
  } = props;

  return (
    <Participants
      dateFormat={dateFormat}
      dayPlaceholder={t('config.booking.form.dayPlaceholder')}
      monthPlaceholder={t('config.booking.form.monthPlaceholder')}
      yearPlaceholder={t('config.booking.form.yearPlaceholder')}
      adultOnly={product.adultOnly}
      childrenBirthdayDateFormatPlaceholder={t(
        'config.booking.form.childrenBirthdayDateFormatPlaceholder',
      )}
      setKids={setKids}
      setAdultsNumber={setAdultsNumber}
      kids={kids}
      adultsNumber={adultsNumber}
      departureDate={cruise.departureDate}
      minAgeInformation={product.minAuthorizedAge.formattedValue || ''}
      adultAge={t('config.booking.form.adultAge')}
      childAge={product.minAuthorizedAge.value}
      kidsLabel={t('config.common.participants.kidsLabel')}
      adultsLabel={t('config.common.participants.adultsLabel')}
      kidsAgeLimit={t('config.common.participants.kidsAgeLimit')}
    />
  );
};
